import _FocusTrap from './src/focus-trap.vue'

export const FocusTrap = _FocusTrap
export default FocusTrap

export * from './src/focus-trap'
export * from './src/tokens'
export * from './src/utils'
